import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import {Note} from '../../Api/NoteTypes';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName} from '../../Toolkit/Icons';
import NoteDialog from '../Dialogs/NoteDialog';
import {DataTableSortMeta} from 'primereact/datatable';
import MTextArea from './TextArea';

type SafeDigNoteRow = {
    data: Note;
}

type Props = {
    rowData: object[];
    saveNote: (data: string) => void;
    jobComplete: boolean;
}

/** */
type State = {
    filters: MTableFilters;
}

class NoteListControl extends MComponent<Props, State> {

    private readonly m_editRef: RefObject<NoteDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_editRef = createRef<NoteDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.new_Click = this.new_Click.bind(this);
        this.editComplete = this.editComplete.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private new_Click(): void {
        this.m_editRef.current!.show(this.editComplete);
    }

    private async editComplete(newNote: string): Promise<void> {
        await this.props.saveNote(newNote);
    }

    private createdTemplate(rowData: SafeDigNoteRow): string | undefined {
        if(rowData.data.createdOn !== null) {
            try {
                return rowData.data.createdOn!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'data.createdOn', order: -1},
        ];
    }

    private textTemplate(rowData: SafeDigNoteRow): ReactElement {
        return <div className="formgrid grid">
            <div className="min-w-full">
                <MTextArea id={rowData.data.noteText}
                           maxLength={10000}
                           disabled={true}
                           initialValue={rowData.data.noteText}
                           autoResize={true}
                           cols={100}
                />
            </div>
        </div>;
    }

    public render(): ReactElement {
        return (
            <React.Fragment>
                <NoteDialog ref={this.m_editRef}/>
                <MToolbar>
                    <MButton label="Add Note"
                             icon={MNewIconName}
                             disabled={this.props.jobComplete}
                             onClick={this.new_Click}/>
                </MToolbar>
                <MTable
                    rowKey="data.notesId"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    sortField={"data.createdOn"}
                    sortOrder={1}
                >

                    <Column field="data.createdOn"
                            header="Created On"
                            dataType="date"
                            body={this.createdTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '10%'}}/>
                    <Column field="data.createdBy"
                            header="Created By"
                            filter={false}
                            sortable={false}
                            style={{width: '15%'}}/>
                    <Column field="data.notesText"
                            header="Text"
                            body={this.textTemplate}
                            filter={false}
                            sortable={false}
                            style={{width: '75%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default NoteListControl;